import React from "react";
import { Button, Grid, Card, CardContent, Typography, Container, Box } from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import translate from "../../../../i18n/translate.js";
import { useHistory } from "react-router-dom";
import "./IsraelFinesPage.css";

const propTypes = {};

const defaultProps = {};

export default function IsraelFinesPage(props) {
  const history = useHistory();

  const options = [
    {
      id: 1,
      title: translate("pay_fine"),
      icon: <PaymentIcon sx={{ fontSize: 60 }} />,
      description: translate("pay_fine_description") || "Pay your Israeli traffic fines online",
      route: "/bills/pay_israel_fines",
      color: "#4CAF50",
    },
    {
      id: 2,
      title: translate("fine_inquiry"),
      icon: <SearchIcon sx={{ fontSize: 60 }} />,
      description: translate("fine_inquiry_description") || "Check and inquire about your traffic fines",
      route: "/bills/inquire_israel_fines",
      color: "#2196F3",
    },
  ];

  return (
    <div className="israel-fines-modern">
      <Container maxWidth="lg">
        {/* Modern Header */}
        <Box className="israel-fines-header">
          <Typography variant="h3" className="israel-fines-title">
            {translate("Israeli Fines")}
          </Typography>
          <Typography variant="subtitle1" className="israel-fines-subtitle">
            {translate("fines_subtitle") || "Choose an option to manage your traffic fines"}
          </Typography>
        </Box>

        {/* Options Cards */}
        <Grid container spacing={4} justifyContent="center" sx={{ marginTop: 4 }}>
          {options.map((option) => (
            <Grid item xs={12} sm={6} md={5} key={option.id}>
              <Card
                className="israel-fines-card"
                onClick={() => history.push(option.route)}
                sx={{
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: `0 12px 24px ${option.color}40`,
                  },
                }}
              >
                <CardContent sx={{ textAlign: "center", padding: 4 }}>
                  <Box
                    sx={{
                      display: "inline-flex",
                      padding: 3,
                      borderRadius: "50%",
                      background: `linear-gradient(135deg, ${option.color}20, ${option.color}10)`,
                      color: option.color,
                      marginBottom: 2,
                    }}
                  >
                    {option.icon}
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      marginBottom: 1,
                      color: "#333",
                    }}
                  >
                    {option.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#666",
                      lineHeight: 1.6,
                    }}
                  >
                    {option.description}
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: 3,
                      background: `linear-gradient(135deg, ${option.color}, ${option.color}DD)`,
                      color: "white",
                      padding: "10px 30px",
                      borderRadius: "25px",
                      textTransform: "none",
                      fontSize: "16px",
                      "&:hover": {
                        background: `linear-gradient(135deg, ${option.color}DD, ${option.color}BB)`,
                      },
                    }}
                  >
                    {translate("Continue")}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Back Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-start", marginTop: 6, marginBottom: 4 }}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/pay_bills")}
            sx={{ minWidth: 120 }}
          >
            {translate("Back")}
          </Button>
        </Box>
      </Container>
    </div>
  );
}

IsraelFinesPage.propTypes = propTypes;
IsraelFinesPage.defaultProps = defaultProps;
